export default {
	huanyinghuilai: 'お帰りなさい',
	wodezhanghu: '私のアカウント',
	gerenxinxi: '個人情報',
	jiatingyupengyou: '家族と友達',
	fukuanshijian: '支払い時間',
	fukuanfangshi: '支払い方法',
	fukuanjine: '支払い金額',
	genggaimima: 'パスワードの変更',
	quebaoxinxizhengque: '情報が正確であることを確認してください。敬称と旅券または他の有効な旅行文書に表示されている名前を正確に入力する必要があります。',
	zhuxiao: 'ログアウト',
	quedingyaodengchuma: '本当にログアウトしますか？',
	tuichuchenggong: 'ログアウト成功しました！',
	nishifeixingchangkema: 'あなたはマイレージ会員ですか',
	lijitianjianindejiarenhepengyou: '今すぐ家族や友達を追加してください',
	tianjianindepengyou: '家族や友達の情報を追加して、よりスムーズに予約できます。',
	xinzeng: '新規',
	lijitianjiaka: '今すぐカードを追加',
	tianjiaka: '次回のためにカードを追加してください。',
	bianji: '編集',
	shanchu: '削除',
	querenshanchuchengkexinxime: '乗客情報を削除してもよろしいですか？',
};
